import type { RouteRecordRaw } from 'vue-router';
import { RouteNames } from '../config/route-names';

export const asyncRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '/post/edit',
        name: RouteNames.JobForm,
        component: () => import('@/views/job/form/index.vue'),
        meta: {
          title: 'menu.jobForm',
          hidden: true,
          activeMenu: '/post/list',
          requiresAuth: true,
        }
      },
      {
        path: '/post/detail',
        name: RouteNames.JobDetail,
        component: () => import('@/views/job/detail/index.vue'),
        meta: {
          title: 'menu.jobDetail',
          hidden: true,
          activeMenu: '/post/list',
          requiresAuth: true,
        }
      },
      {
        path: '/data-summary',
        name: RouteNames.DataSummary,
        meta: {
          title: 'menu.dataSummary',
          icon: 'dataview',
          showInMenu: true,
          requiresAuth: false,
        },
        children: [
          {
            path: '/data-summary/overview',
            name: RouteNames.DataOverview,
            component: () => import('@/views/dataSummary/index.vue'),
            meta: {
              title: 'menu.dataOverview',
              showInMenu: true,
              requiresAuth: true,
            },
          },
          {
            path: '/data-summary/headhunter',
            name: RouteNames.HeadhunterBoard,
            component: () => import('@/views/dataSummary/HeadhunterBoard.vue'),
            meta: {
              title: 'menu.headhunterBoard',
              showInMenu: true,
              requiresAuth: true,
            },
          },
          {
            path: '/data-summary/internal',
            name: RouteNames.InternalBoard,
            component: () => import('@/views/dataSummary/InternalBoard.vue'),
            meta: {
              title: 'menu.internalBoard',
              showInMenu: true,
              requiresAuth: true,
            },
          },
          {
            path: '/data-summary/my-board',
            name: RouteNames.MyBoard,
            component: () => import('@/views/dataSummary/MyBoard.vue'),
            meta: {
              title: 'menu.myBoard',
              showInMenu: true,
              requiresAuth: true,
            },
          },
        ]
      },
      {
        path: '/post',
        name: RouteNames.JobManage,
        meta: {
          title: 'menu.jobMananger',
          icon: 'job-nav',
          showInMenu: true,
          requiresAuth: false,
        },
        children: [
          {
            path: '/post/list',
            name: RouteNames.Job,
            component: () => import('@/views/job/list/index.vue'),
            meta: {
              title: 'menu.job',
              showInMenu: true,
              requiresAuth: true,
            },
          },
          {
            path: '/post/agent-manage',
            name: RouteNames.AgentManage,
            component: () => import('@/views/job/agent-manage/index.vue'),
            meta: {
              title: 'menu.agentManage',
              showInMenu: true,
              requiresAuth: true,
            },
          },
        ]
      },
      {
        path: '/recruitment',
        name: RouteNames.Candidate,
        meta: {
          title: 'menu.candidate',
          icon: 'users',
          showInMenu: true,
          // 有二级菜单的需要配置requiresAuth:false，避免父级菜单被权限过滤掉
          requiresAuth: false,
        },
        children: [
          {
            path: '/recruitment/selection/list',
            name: RouteNames.CandidateSelecting,
            component: () => import('@/views/candidate/selecting/index.vue'),
            meta: {
              title: 'menu.candidateSelecting',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/list',
            name: RouteNames.CandidateRegistered,
            component: () => import('@/views/candidate/registered/index.vue'),
            meta: {
              title: 'menu.candidateRegistered',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/edit',
            name: RouteNames.CandidateEdit,
            component: () => import('@/views/candidate/registered/edit/index.vue'),
            meta: {
              title: 'menu.candidateEdit',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/candidate/list',
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/candidate/detail',
            name: RouteNames.CandidateDetail,
            component: () => import('@/views/candidate/registered/detail/index.vue'),
            meta: {
              title: 'menu.candidateDetail',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/candidate/list',
              requiresAuth: true,
            }
          },
          {
            path: '/recruitment/selection/detail',
            name: RouteNames.CandidateSelectingDetail,
            component: () => import('@/views/candidate/selecting/detail/index.vue'),
            meta: {
              title: 'menu.candidateSelectingDetail',
              showInMenu: false,
              hidden: true,
              activeMenu: '/recruitment/selection/list',
              requiresAuth: true,
            }
          },
        ]
      },
      {
        path: '/chat',
        name: RouteNames.Chat,
        component: () => import('@/views/chat/index.vue'),
        meta: {
          title: 'menu.headhunterChat',
          icon: 'chat',
          showInMenu: true,
          requiresAuth: true,
        }
      },
      {
        path: 'settings',
        name: RouteNames.Settings,
        redirect: '/company',
        meta: {
          title: 'menu.settings',
          icon: 'setting',
          showInMenu: true,
          requiresAuth: false
        },
        children: [
          {
            path: '/company',
            name: RouteNames.CompanySetting,
            component: () => import('@/views/company/index.vue'),
            meta: {
              title: 'menu.companySetting',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/account/list',
            name: RouteNames.Account,
            component: () => import('@/views/account/index.vue'),
            meta: {
              title: 'menu.account',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/account/detail',
            name: RouteNames.AccountDetail,
            component: () => import('@/views/account/detail.vue'),
            meta: {
              hidden: true,
              title: 'menu.accountDetail',
              requiresAuth: false
            }
          },
          {
            path: '/setting/affiliation/list',
            name: RouteNames.DepartmentSetting,
            component: () => import('@/views/settings/department.vue'),
            meta: {
              title: 'menu.departmentSetting',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/selection',
            name: RouteNames.InterviewSetting,
            component: () => import('@/views/settings/interview.vue'),
            meta: {
              title: 'menu.interviewSetting',
              showInMenu: true
            }
          },
          {
            path: '/setting/selection_process/list',
            name: RouteNames.InterviewProcess,
            component: () => import('@/views/settings/interview-process/index.vue'),
            meta: {
              title: 'menu.interviewProcess',
              activeMenu: '/setting/selection',
              hidden: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/selection_process/edit',
            name: RouteNames.InterviewProcessDetail,
            component: () => import('@/views/settings/interview-process/detail.vue'),
            meta: {
              title: 'menu.interviewProcessDetail',
              activeMenu: '/setting/selection',
              hidden: true,
              
            }
          },
          {
            path: '/setting/channel_source/list',
            name: RouteNames.InterviewChannel,
            component: () => import('@/views/settings/interview-channel/index.vue'),
            meta: {
              title: 'menu.interviewChannel',
              activeMenu: '/setting/selection',
              hidden: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/notify',
            name: RouteNames.Notify,
            component: () => import('@/views/settings/notify/index.vue'),
            meta: {
              title: 'menu.notify',
              showInMenu: true,
              requiresAuth: true,
            }
          },
          {
            path: '/setting/notify/settings',
            name: 'NotifySettings',
            component: () => import('@/views/settings/notify/settings.vue'),
            meta: {
              title: 'menu.notifySettings',
              activeMenu: '/setting/notify',
              hidden: true,
              requiresAuth: true,
            }
          },
        ]
      },
      // 组件示例（仅开发环境）
      // {
      //   path: '/examples',
      //   name: 'Examples',
      //   meta: {
      //     title: '组件示例',
      //     icon: 'document',
      //     roles: [],
      //     showInMenu: true
      //   },
      //   children: [
      //     {
      //       path: '/examples/info-table',
      //       name: 'InfoTableExample',
      //       component: () => import('@/components/business-components/info-table/example.vue'),
      //       meta: {
      //         title: 'InfoTable 示例',
      //         roles: ['ROLE_BUSINESS_ADMIN', 'ROLE_BUSINESS_USER'],
      //         showInMenu: true
      //       }
      //     },
      //   ]
      // },
      // 404错误页面路由
      {
        path: '/404',
        name: RouteNames.Error404,
        component: () => import('@/views/error/404.vue'),
        meta: { hidden: true, title: 'menu.error404', requiresAuth: false }
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/404',
        meta: { hidden: true, requiresAuth: false}
      },

      // 403无权限页面 - 全屏展示，不在布局内
      {
        path: '/403',
        name: RouteNames.Error403,
        component: () => import('@/views/error/403.vue'),
        meta: { hidden: true, title: 'menu.error403', requiresAuth: false }
      }
    ]
  },
];
